export default "__VITE_ASSET__BevCkIEp__"